// src/components/Footer.js
import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-dark text-light text-center py-3">
      <p className="mb-0">&copy; 2025 Fantasy League. All Rights Reserved.</p>
    </footer>
  );
};

export default Footer;
